(function(){
  var d=document,w=window;
  d.documentElement.classList.add('v-js');
  var reduce=w.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine=w.matchMedia('(pointer: fine)').matches;

  function init(root){
    root=root||d;
    var els=root.querySelectorAll('.v-reveal:not(.is-in)');
    if(!('IntersectionObserver' in w)||reduce){els.forEach(function(e){e.classList.add('is-in')});}
    else{
      var io=new IntersectionObserver(function(en){en.forEach(function(x){if(x.isIntersecting){x.target.classList.add('is-in');io.unobserve(x.target);}})},{threshold:.12,rootMargin:'0px 0px -6% 0px'});
      els.forEach(function(e){io.observe(e)});
    }
    root.querySelectorAll('[data-sparkles]').forEach(function(s){
      if(s.dataset.done)return;s.dataset.done=1;
      for(var i=0;i<14;i++){var p=d.createElement('span');p.className='v-sparkle';p.style.top=(10+Math.random()*80)+'%';p.style.left=(10+Math.random()*80)+'%';p.style.animationDelay=(Math.random()*3.6)+'s';s.appendChild(p);}
    });
    root.querySelectorAll('[data-tilt]').forEach(function(stage){
      var img=stage.querySelector('.v-hero__img');if(!img||!fine||reduce)return;
      stage.addEventListener('mousemove',function(e){var r=stage.getBoundingClientRect();var x=(e.clientX-r.left)/r.width-.5,y=(e.clientY-r.top)/r.height-.5;img.style.transform='rotateY('+(x*16)+'deg) rotateX('+(-y*16)+'deg) scale(1.03)';});
      stage.addEventListener('mouseleave',function(){img.style.transform='';});
    });
    if(fine&&!reduce)root.querySelectorAll('[data-card-tilt]').forEach(function(c){
      c.addEventListener('mousemove',function(e){var r=c.getBoundingClientRect();var x=(e.clientX-r.left)/r.width,y=(e.clientY-r.top)/r.height;c.style.transform='perspective(900px) rotateY('+((x-.5)*8)+'deg) rotateX('+((.5-y)*8)+'deg) translateY(-6px)';c.style.setProperty('--gx',x*100+'%');c.style.setProperty('--gy',y*100+'%');});
      c.addEventListener('mouseleave',function(){c.style.transform='';});
    });
    root.querySelectorAll('[data-tech]').forEach(function(t){
      var steps=t.querySelectorAll('.v-step'),dots=t.querySelectorAll('.v-tech__dots span'),img=t.querySelector('.v-tech__sticky img');
      if(!steps.length)return;
      function act(i){steps.forEach(function(s,j){s.classList.toggle('is-active',j===i)});dots.forEach(function(s,j){s.classList.toggle('is-on',j===i)});if(img&&!reduce)img.style.transform='scale('+(1+i*.06)+') rotate('+(i%2?-1.5:1.5)+'deg)';}
      act(0);
      if(!('IntersectionObserver' in w))return;
      var o=new IntersectionObserver(function(en){en.forEach(function(x){if(x.isIntersecting)act([].indexOf.call(steps,x.target));})},{rootMargin:'-45% 0px -45% 0px'});
      steps.forEach(function(s){o.observe(s)});
    });
  }

  var par=[];
  function collect(){par=[].slice.call(d.querySelectorAll('[data-parallax]'));}
  function onScroll(){
    var vh=w.innerHeight;
    if(!reduce)par.forEach(function(el){var r=el.parentElement.getBoundingClientRect();if(r.bottom<0||r.top>vh)return;var p=(r.top+r.height/2-vh/2)/vh;var f=parseFloat(el.dataset.parallax)||.12;el.style.transform=(el.dataset.scale?'scale('+el.dataset.scale+') ':'')+'translate3d(0,'+(p*f*-100)+'px,0)';});
    var s=d.querySelector('.v-sticky'),anchor=d.querySelector('[data-buy-anchor] .v-buy');
    if(s&&anchor){var b=anchor.getBoundingClientRect();s.classList.toggle('is-show',b.bottom<0);}
  }
  var ticking=false;
  w.addEventListener('scroll',function(){if(!ticking){ticking=true;requestAnimationFrame(function(){onScroll();ticking=false;});}},{passive:true});

  function money(c){var n=c/100;return '₪'+(n%1===0?n.toLocaleString('he-IL'):n.toLocaleString('he-IL',{minimumFractionDigits:2,maximumFractionDigits:2}));}

  function openDrawer(html){
    var drawer=d.getElementById('cart-drawer');
    if(!drawer){location.href='/cart';return;}
    if(html){
      try{
        var doc=new DOMParser().parseFromString(html,'text/html');
        var fresh=doc.querySelector('.cart-drawer__inner'),old=drawer.querySelector('.cart-drawer__inner');
        if(fresh&&old){old.replaceWith(d.importNode(fresh,true));}
      }catch(e){}
    }
    var go=function(){if(typeof drawer.open==='function'){drawer.open();}else{location.href='/cart';}};
    if(customElements.get('theme-drawer'))go();else customElements.whenDefined('theme-drawer').then(go);
  }
  function bump(count){
    d.querySelectorAll('.cart-bubble').forEach(function(b){b.classList.remove('visually-hidden');});
    d.querySelectorAll('.cart-bubble__text-count').forEach(function(e){e.classList.remove('hidden');e.textContent=count;});
    d.querySelectorAll('.theme-drawer__badge').forEach(function(e){e.classList.remove('visually-hidden');e.textContent=count;});
  }

  /* Adds one or more variants to the cart in a single request, then refreshes and opens the cart drawer.
     onFail is called if Shopify refuses the request (e.g. a colour is sold out), so nothing partial is assumed. */
  function addItems(items,btn,onFail){
    if(btn){btn.classList.add('is-loading');btn.disabled=true;}
    var root=(w.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
    var html=null;
    var done=function(){if(btn){btn.classList.remove('is-loading');btn.disabled=false;}};
    return fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:items,sections:'cart-drawer-section',sections_url:location.pathname})})
      .then(function(r){return r.json().then(function(j){if(!r.ok){var e=new Error(j&&(j.description||j.message)||'error');e.data=j;throw e;}return j;});})
      .then(function(res){html=res&&res.sections&&res.sections['cart-drawer-section'];return fetch(root+'cart.js').then(function(r){return r.json()});})
      .then(function(c){done();bump(c.item_count);openDrawer(html);})
      .catch(function(err){done();if(onFail)onFail(err);});
  }
  w.velinoAddItems=addItems;

  /* Bundle cards: click anywhere on a card selects it; colour chips inside a card pick each item's variant. */
  function initBundles(root){
    (root||d).querySelectorAll('[data-v-bundle],[data-v-bundle-home]').forEach(function(b){
      if(b.dataset.vbReady)return;b.dataset.vbReady=1;
      var cards=[].slice.call(b.querySelectorAll('[data-v-bcard]'));
      function pick(card){
        cards.forEach(function(c){var on=c===card;c.classList.toggle('is-on',on);var r=c.querySelector('[data-v-bopt]');if(r)r.checked=on;c.setAttribute('aria-checked',on?'true':'false');});
        var m=b.querySelector('[data-v-bmsg]');if(m)m.textContent='';
        b.dispatchEvent(new CustomEvent('vb:change',{bubbles:true}));
      }
      cards.forEach(function(c){
        c.setAttribute('role','radio');c.setAttribute('aria-checked',c.classList.contains('is-on')?'true':'false');
        c.addEventListener('click',function(e){if(e.target.closest('.vb-chip'))return;pick(c);});
        c.addEventListener('keydown',function(e){if(e.target===c&&(e.key==='Enter'||e.key===' ')){e.preventDefault();pick(c);}});
      });
      b.querySelectorAll('.vb-chip').forEach(function(ch){
        ch.addEventListener('click',function(e){
          e.preventDefault();e.stopPropagation();
          if(ch.disabled)return;
          var pk=ch.closest('[data-v-bpick]');
          var card=ch.closest('[data-v-bcard]');
          if(card&&!card.classList.contains('is-on'))pick(card);
          var targets=[pk];
          /* the bracelet colour is shared by all cards on the product page */
          if(pk.dataset.role==='base'&&b.hasAttribute('data-v-bundle'))targets=[].slice.call(b.querySelectorAll('[data-v-bpick][data-role="base"]'));
          targets.forEach(function(t){setChip(t,ch.dataset.vid);});
          if(pk.dataset.role==='base'&&b.hasAttribute('data-v-bundle')){
            b.dispatchEvent(new CustomEvent('vb:base',{bubbles:true,detail:{id:ch.dataset.vid}}));
          }
        });
      });
      var homeBtn=b.querySelector('[data-v-bundle-add]');
      if(homeBtn)homeBtn.addEventListener('click',function(e){
        e.preventDefault();
        var items=bundleItems(b,false);
        if(!items||!items.length)return;
        addItems(items,homeBtn,function(){bundleError(b);});
      });
    });
  }
  function setChip(pk,vid){
    pk.querySelectorAll('.vb-chip').forEach(function(c){var on=c.dataset.vid===String(vid);c.classList.toggle('is-on',on);c.setAttribute('aria-checked',on?'true':'false');if(on){var n=pk.querySelector('[data-v-bname]');if(n)n.textContent=c.dataset.name;}});
  }
  /* Variants chosen in the selected card. skipBase: the bracelet comes from the product form instead. */
  function bundleItems(b,skipBase){
    var card=b.querySelector('[data-v-bcard].is-on');
    if(!card)return [];
    var out=[];
    card.querySelectorAll('[data-v-bpick]').forEach(function(pk){
      if(skipBase&&pk.dataset.role==='base')return;
      var on=pk.querySelector('.vb-chip.is-on');
      if(on)out.push({id:+on.dataset.vid,quantity:1});
    });
    return out;
  }
  function bundleError(b){
    var m=b.querySelector('[data-v-bmsg]');
    if(m)m.textContent='לא הצלחנו להוסיף את החבילה. ייתכן שאחד הגוונים שבחרת אזל, נסי לבחור גוון אחר.';
  }

  function initProduct(root){
    (root||d).querySelectorAll('[data-v-product]').forEach(function(p){
      if(p.dataset.ready)return;p.dataset.ready=1;
      var data=JSON.parse(p.querySelector('[data-v-json]').textContent);
      var idInput=p.querySelector('input[name="id"]');
      var main=p.querySelectorAll('.v-gm'),thumbs=p.querySelectorAll('.v-thumb');
      function show(mid){main.forEach(function(im){im.classList.toggle('is-on',im.dataset.mid==String(mid))});thumbs.forEach(function(t){t.classList.toggle('is-on',t.dataset.mid==String(mid))});}
      thumbs.forEach(function(t){t.addEventListener('click',function(){show(t.dataset.mid)})});
      function setVariant(v){
        if(!v)return;idInput.value=v.id;
        p.querySelectorAll('[data-v-price]').forEach(function(e){e.textContent=money(v.price)});
        p.querySelectorAll('[data-v-compare]').forEach(function(e){e.textContent=v.compare>v.price?money(v.compare):'';e.hidden=!(v.compare>v.price)});
        p.querySelectorAll('[data-v-save]').forEach(function(e){e.textContent=v.compare>v.price?'חיסכון של '+money(v.compare-v.price):'';e.hidden=!(v.compare>v.price)});
        p.querySelectorAll('[data-v-color-name]').forEach(function(e){e.textContent=v.title});
        if(v.media)show(v.media);
        var st=p.querySelector('[data-v-stock]');
        if(st){st.className='v-stock';var t=st.querySelector('[data-v-stock-text]');
          if(!v.available){st.classList.add('v-stock--out');t.innerHTML='<b>הגוון הזה אזל כרגע.</b> מלאי חדש בדרך';}
          else if(v.tracked&&v.qty>0&&v.qty<=10){st.classList.add('v-stock--low');t.innerHTML='<b>במלאי, נשארו '+v.qty+' יחידות בלבד.</b> יוצא אלייך תוך 3 ימי עסקים';}
          else{t.innerHTML='<b>במלאי.</b> יוצא אלייך תוך 3 ימי עסקים';}
        }
        d.querySelectorAll('[data-v-add],[data-v-sticky-buy]').forEach(function(b){b.disabled=!v.available});
        d.querySelectorAll('[data-v-sticky-price]').forEach(function(e){e.textContent=money(v.price)});
        if(p.dataset.updateUrl&&history.replaceState){var u=new URL(location.href);u.searchParams.set('variant',v.id);history.replaceState({},'',u);}
        if(typeof syncBundle==='function')syncBundle();
      }
      p.querySelectorAll('.v-swatch input').forEach(function(r){r.addEventListener('change',function(){
        p.querySelectorAll('.v-swatch').forEach(function(s){s.classList.toggle('is-on',s.contains(r))});
        setVariant(data.variants.find(function(v){return String(v.id)===r.value}));
      })});
      var form=p.querySelector('form[action*="/cart/add"]');
      var bundle=p.querySelector('[data-v-bundle]');
      var faLabel=p.querySelector('[data-v-add] span');
      var baseLabel=faLabel?faLabel.textContent:'';
      function syncBundle(){
        if(!bundle)return;
        var card=bundle.querySelector('[data-v-bcard].is-on');if(!card)return;
        var pr=+card.dataset.price;
        if(faLabel&&pr)faLabel.textContent=baseLabel+' · '+money(pr);
        if(pr)d.querySelectorAll('[data-v-sticky-price]').forEach(function(e){e.textContent=money(pr)});
        if(card.dataset.name)d.querySelectorAll('.v-sticky__txt b').forEach(function(e){e.textContent=card.dataset.name});
      }
      if(bundle){
        bundle.addEventListener('vb:change',syncBundle);
        bundle.addEventListener('vb:base',function(e){
          var inp=p.querySelector('.v-swatch input[value="'+e.detail.id+'"]');
          if(inp){inp.checked=true;inp.dispatchEvent(new Event('change'));}
          else{idInput.value=e.detail.id;}
        });
        syncBundle();
      }
      function add(btn){
        var items=[{id:+idInput.value,quantity:1}];
        var extra=bundle?bundleItems(bundle,true):[];
        items=items.concat(extra);
        addItems(items,btn,function(){
          if(extra.length){bundleError(bundle);}
          else if(form){form.submit();}
        });
      }
      var fa=p.querySelector('[data-v-add]');
      if(fa)fa.addEventListener('click',function(e){e.preventDefault();add(fa)});
      p.querySelectorAll('[data-v-sticky-buy]').forEach(function(b){b.addEventListener('click',function(e){e.preventDefault();add(b)})});
    });
  }

  function boot(){init();initBundles();initProduct();collect();onScroll();}
  if(d.readyState!=='loading')boot();else d.addEventListener('DOMContentLoaded',boot);
  d.addEventListener('shopify:section:load',function(e){init(e.target);initBundles(e.target);initProduct(e.target);collect();onScroll();});
})();
